<template>
	<!-- 移除el-dialog，改为固定定位的div -->
	<div v-if="isShow" class="rtc-group-join-fixed">
		<div class="rtc-group-join">
			<div class="host-info">
				<head-image :name="rtcInfo.host.nickName" :url="rtcInfo.host.headImage" :size="80"></head-image>
				<div class="host-text">{{ '发起人:' + rtcInfo.host.nickName }}</div>
			</div>
			<div class="users-info">
				<div class="call-status">（群聊）{{ rtcInfo.userInfos.length + '人正在通话中' }}</div>
				<div class="user-list">
					<div class="user-item" v-for="(user, index) in rtcInfo.userInfos" :key="`user-${user.id}-${index}`">
						<head-image :url="user.headImage" :name="user.nickName" :size="40">
						</head-image>
					</div>
				</div>
				<div class="countdown-tip">未接听将于 {{ countdownText }} 后自动取消</div>
			</div>
			
			<!-- 使用单聊的绿色/红色按钮样式 -->
			<div class="btn-group">
				<div class="icon iconfont icon-phone-accept accept" @click="onOk()" title="接受"></div>
				<div class="icon iconfont icon-phone-reject reject" @click="onCancel()" title="拒绝"></div>
			</div>
		</div>
		
		<!-- 音频元素将在JavaScript中动态创建 -->
	</div>
</template>

<script>
import HeadImage from '@/components/common/HeadImage'
import RtcGroupApi from "@/api/rtcGroupApi";
import {
	CALL_SOUND_ENABLED_STORAGE_KEY,
	CALL_SOUND_STORAGE_KEY,
	getCallSoundOption
} from '@/config/callSoundOptions';

export default {
	name: "rtcGroupJoin",
	components: {
		HeadImage
	},
	data() {
		return {
      // API实例
      API: new RtcGroupApi(),

			isShow: false,
			rtcInfo: {
				host: {},
				userInfos: []
			},
			callAudio: null, // 呼叫音播放器
			isPlaying: false, // 是否正在播放
			countdown: 90, // 剩余秒数，运行时使用后端统一配置
			countdownTimer: null, // 倒计时计时器
			// App 可能在 Web 接听前就开始协商，先保留这些信令，接听后交给通话窗口处理
			pendingRtcMessages: []
		}
	},
	props: {
		groupId: {
			type: Number
		}
	},
	computed: {
		countdownText() {
			const totalSeconds = Math.max(0, Math.floor(Number(this.countdown) || 0));
			const minutes = Math.floor(totalSeconds / 60);
			const seconds = totalSeconds % 60;
			return minutes > 0 ? `${minutes}分${seconds}秒` : `${seconds}秒`;
		}
	},
	mounted() {
		// 组件挂载完成，音频将在弹窗打开时初始化
		console.log('RtcGroupJoin组件已挂载');
	},
	beforeDestroy() {
		// 组件销毁前停止音频与倒计时
		this.stopCallAudio();
		this.clearCountdown();
	},
	methods: {
		resolveCallTimeoutSeconds() {
			const inviteTimeout = Number(this.rtcInfo && this.rtcInfo.callTimeoutSeconds);
			const configTimeout = Number(this.configStore && this.configStore.webrtc &&
				this.configStore.webrtc.callTimeoutSeconds);
			const timeout = inviteTimeout > 0 ? inviteTimeout : configTimeout;
			return Number.isFinite(timeout) && timeout > 0 ? Math.floor(timeout) : 90;
		},
		// 初始化呼叫音
		initCallAudio() {
			console.log('=== 开始初始化web端群聊邀请呼叫音 ===');
			
			try {
				// 如果音频元素已经存在，先清理
				if (this.callAudio) {
					this.callAudio.pause();
					this.callAudio.remove();
					this.callAudio = null;
				}
				
				// 动态创建音频元素
				this.callAudio = document.createElement('audio');
				console.log('音频元素创建成功:', !!this.callAudio);
				
				// 设置音频属性
				this.callAudio.preload = 'auto';
				this.callAudio.style.display = 'none';
				const sound = getCallSoundOption(localStorage.getItem(CALL_SOUND_STORAGE_KEY));
				this.callAudio.src = sound.src;
				this.callAudio.loop = true;
				
				console.log('音频属性设置完成:', {
					src: this.callAudio.src,
					loop: this.callAudio.loop,
					preload: this.callAudio.preload
				});
				
				// 添加音频事件监听
				this.callAudio.addEventListener('loadstart', () => {
					console.log('🎵 web端呼叫音开始加载');
					console.log('加载状态:', {
						readyState: this.callAudio.readyState,
						networkState: this.callAudio.networkState,
						src: this.callAudio.src
					});
				});
				
				this.callAudio.addEventListener('canplay', () => {
					console.log('🎵 web端呼叫音可以播放');
					console.log('播放就绪状态:', {
						readyState: this.callAudio.readyState,
						duration: this.callAudio.duration,
						loaded: this.callAudio.buffered.length > 0 ? this.callAudio.buffered.end(0) : 0
					});
				});
				
				this.callAudio.addEventListener('play', () => {
					console.log('🎵 web端呼叫音开始播放');
					this.isPlaying = true;
				});
				
				this.callAudio.addEventListener('pause', () => {
					console.log('🎵 web端呼叫音暂停');
					this.isPlaying = false;
				});
				
				this.callAudio.addEventListener('ended', () => {
					console.log('🎵 web端呼叫音播放结束');
					this.isPlaying = false;
				});
				
				this.callAudio.addEventListener('error', (error) => {
					console.error('❌ web端呼叫音播放错误:', error);
					console.error('错误详情:', {
						error: error,
						target: error.target,
						readyState: this.callAudio.readyState,
						networkState: this.callAudio.networkState,
						src: this.callAudio.src
					});
					this.isPlaying = false;
				});
				
				// 将音频元素添加到body中
				document.body.appendChild(this.callAudio);
				console.log('音频元素已添加到DOM');
				
				console.log('✅ web端群聊邀请呼叫音初始化成功');
				
			} catch (error) {
				console.error('❌ 初始化web端呼叫音失败:', error);
				console.error('错误详情:', {
					name: error.name,
					message: error.message,
					stack: error.stack
				});
			}
		},
		
		// 播放呼叫音
		playCallAudio() {
			if (localStorage.getItem(CALL_SOUND_ENABLED_STORAGE_KEY) === 'false') {
				this.stopCallAudio();
				return;
			}
			console.log('playCallAudio 调用，状态检查:', {
				hasCallAudio: !!this.callAudio,
				isPlaying: this.isPlaying,
				callAudioType: this.callAudio ? typeof this.callAudio : 'undefined'
			});
			
			if (this.callAudio && !this.isPlaying) {
				console.log('开始播放web端群聊邀请呼叫音');
				this.callAudio.play().then(() => {
					console.log('✅ web端呼叫音开始播放');
				}).catch(error => {
					console.error('❌ web端呼叫音播放失败:', error);
					// 可能是浏览器自动播放策略阻止，提示用户
					console.log('提示：可能需要用户交互才能播放音频');
					
					// 添加用户交互后的重试机制
					this.addUserInteractionRetry();
				});
			} else {
				console.log('无法播放呼叫音:', {
					reason: !this.callAudio ? '音频元素未初始化' : '正在播放中',
					callAudio: this.callAudio,
					isPlaying: this.isPlaying
				});
			}
		},
		
		// 添加用户交互后的重试机制
		addUserInteractionRetry() {
			console.log('添加用户交互重试机制');
			
			// 监听用户点击事件，尝试重新播放
			const handleClick = () => {
				console.log('检测到用户交互，尝试重新播放呼叫音');
				if (localStorage.getItem(CALL_SOUND_ENABLED_STORAGE_KEY) !== 'false' && this.callAudio && !this.isPlaying) {
					this.callAudio.play().then(() => {
						console.log('✅ 用户交互后呼叫音播放成功');
					}).catch(error => {
						console.error('❌ 用户交互后呼叫音播放仍然失败:', error);
					});
				}
				
				// 移除事件监听器
				document.removeEventListener('click', handleClick);
				document.removeEventListener('touchstart', handleClick);
			};
			
			// 添加事件监听器
			document.addEventListener('click', handleClick, { once: true });
			document.addEventListener('touchstart', handleClick, { once: true });
		},
		
		// 停止呼叫音
		stopCallAudio() {
			if (this.callAudio) {
				console.log('停止web端群聊邀请呼叫音');
				this.callAudio.pause();
				this.callAudio.currentTime = 0;
				this.isPlaying = false;
				
				// 从DOM中移除音频元素
				try {
					if (this.callAudio.parentNode) {
						this.callAudio.parentNode.removeChild(this.callAudio);
					}
				} catch (e) {
					console.log('移除音频元素时出错:', e);
				}
				
				this.callAudio = null;
				console.log('✅ web端呼叫音已停止并清理');
			}
		},
		
		// 启动倒计时
		startCountdown(expiresAt = 0) {
			this.clearCountdown();
			this.countdown = Number(expiresAt) > Date.now() ?
				Math.max(1, Math.ceil((Number(expiresAt) - Date.now()) / 1000)) :
				this.resolveCallTimeoutSeconds();
			this.countdownTimer = setInterval(() => {
				this.countdown -= 1;
				if (this.countdown <= 0) {
					this.countdown = 0;
					console.log('倒计时结束，自动取消加入通话');
					this.onTimeout();
				}
			}, 1000);
		},
		
		// 清理倒计时
		clearCountdown() {
			if (this.countdownTimer) {
				clearInterval(this.countdownTimer);
				this.countdownTimer = null;
			}
		},
		
			async open(rtcInfo) {
				console.log('RtcGroupJoin.open called with:', rtcInfo);
				console.log('RtcGroupJoin.open - userInfos详情:', rtcInfo.userInfos.map(u => ({id: u.id, nickName: u.nickName})));
				const active = await this.isInviteStillActive(rtcInfo);
				if (!active) {
					this.handleRemoteCancel(false);
					return;
				}
				this.rtcInfo = rtcInfo;
				this.pendingRtcMessages = [];
				this.isShow = true;
				const currentUserId = this.userStore.userInfo.id;
				const callId = rtcInfo.inviteCallIds && rtcInfo.inviteCallIds[currentUserId];
				let ringingData = null;
				if (callId) {
					ringingData = await this.API.ringing(`group:${rtcInfo.groupId}`, callId).catch((error) => {
						console.warn('上报 Web 群聊响铃失败，使用邀请截止时间:', error);
						return null;
					});
					if (ringingData && ringingData.active === false) {
						this.handleRemoteCancel(false);
						return;
					}
				}
				
				// 弹窗显示后初始化并播放呼叫音，同时启动倒计时
				this.$nextTick(() => {
					console.log('弹窗已显示，初始化音频');
					this.initCallAudio();
					const inviteDeadline = rtcInfo.inviteExpiresAt && rtcInfo.inviteExpiresAt[currentUserId];
					this.startCountdown((ringingData && ringingData.expiresAt) || inviteDeadline);
					
					// 等待音频初始化完成后播放
					setTimeout(() => {
						console.log('准备播放呼叫音');
						this.playCallAudio();
					}, 100);
				});
			},
			
			async onOk() {
				const active = await this.isInviteStillActive();
				if (!active) {
					this.handleRemoteCancel();
					return;
				}
				// 停止呼叫音
				this.stopCallAudio();
				this.clearCountdown();
				
				this.isShow = false;
			console.log('RtcGroupJoin.onOk - 原始userInfos:', this.rtcInfo.userInfos);
			console.log('RtcGroupJoin.onOk - 当前用户:', this.userStore.userInfo);
			console.log('RtcGroupJoin.onOk - 原始userInfos详情:', this.rtcInfo.userInfos.map(u => ({id: u.id, nickName: u.nickName})));
			
			// 创建userInfos的副本，避免修改原始数据
			let userInfos = [...this.rtcInfo.userInfos];
			let mine = this.userStore.userInfo;
		
			console.log("打印mine:"+JSON.stringify(mine));
		
			// 检查是否已经包含当前用户
			const existingUser = userInfos.find((user) => user.id == mine.id);
			console.log('RtcGroupJoin.onOk - 是否已包含当前用户:', !!existingUser);
			
			if (!existingUser) {
				// 加入自己的信息
				userInfos.push({
					id: mine.id,
					nickName: mine.nickName,
					headImage: mine.headImageThumb,
					isCamera: false,
					isMicroPhone: true
				})
				console.log('RtcGroupJoin.onOk - 已添加当前用户');
			}
			
			console.log('RtcGroupJoin.onOk - 最终userInfos:', userInfos);
			console.log('RtcGroupJoin.onOk - 最终userInfos详情:', userInfos.map(u => ({id: u.id, nickName: u.nickName})));
			
			// 添加当前用户到groupStore
			const currentUser = {
				id: mine.id,
				nickName: mine.nickName,
				headImage: mine.headImageThumb,
				isCamera: false,
				isMicroPhone: true
			};
			this.groupStore.addAcceptedUser(this.rtcInfo.groupId, currentUser);
			console.log('已将当前用户添加到groupStore');
			
			let rtcInfo = {
				isHost: false,
				groupId: this.rtcInfo.groupId,
				inviterId: this.rtcInfo.host.id,
				userInfos: userInfos,
				pendingMessages: [...this.pendingRtcMessages]
			}
			this.pendingRtcMessages = [];
			
			console.log('RtcGroupJoin.onOk - 发送的rtcInfo:', rtcInfo);
			
				// 通过home.vue打开多人视频窗口
				this.$eventBus.$emit("openGroupVideo", rtcInfo);
			},
			async isInviteStillActive(inviteInfo = this.rtcInfo) {
				const groupId = inviteInfo && inviteInfo.groupId;
				if (!groupId) {
					return false;
				}
				try {
					const status = await this.API.status(groupId);
					const inviteHostId = inviteInfo && inviteInfo.host && inviteInfo.host.id !== undefined && inviteInfo.host.id !== null
						? String(inviteInfo.host.id) : '';
					const statusHostId = status && status.hostId !== undefined && status.hostId !== null
						? String(status.hostId) : '';
					const incoming = !!(status && status.active && status.incoming);
					const hostMatched = !inviteHostId || !statusHostId || inviteHostId === statusHostId;
					if (!incoming || !hostMatched) {
						console.log('群聊邀请已失效，忽略加入弹窗:', {
							groupId,
							status
						});
						return false;
					}
					return true;
				} catch (error) {
					console.warn('确认群聊邀请状态失败，忽略加入弹窗:', error);
					return false;
				}
			},
			onRTCMessage(msg) {
				if (!msg) {
					return;
				}
				const currentGroupId = this.rtcInfo && this.rtcInfo.groupId;
				if (!this.isShow || !currentGroupId || String(msg.groupId) !== String(currentGroupId)) {
					return;
				}
				if (msg.type === this.$enums.MESSAGE_TYPE.RTC_GROUP_CANCEL) {
					this.handleRemoteCancel();
					return;
				}
				const negotiationTypes = [
					this.$enums.MESSAGE_TYPE.RTC_GROUP_OFFER,
					this.$enums.MESSAGE_TYPE.RTC_GROUP_ANSWER,
					this.$enums.MESSAGE_TYPE.RTC_GROUP_CANDIDATE
				];
				if (negotiationTypes.includes(msg.type)) {
					this.pendingRtcMessages.push(msg);
					console.log('Web 群聊尚未接听，暂存协商信令:', msg.type, msg.sendId);
				}
			},
			handleRemoteCancel(showMessage = true) {
				this.stopCallAudio();
				this.clearCountdown();
				this.isShow = false;
				this.pendingRtcMessages = [];
				if (showMessage) {
					this.$message.info('群聊通话已取消');
				}
			},
			onCancel() {
				// 停止呼叫音
				this.stopCallAudio();
				this.clearCountdown();
			
			console.log('拒绝群聊');
			this.API.reject(this.rtcInfo.groupId, this.userStore.userInfo.id);
			
			this.isShow = false;
			this.pendingRtcMessages = [];
		},
		
		onTimeout() {
			// 停止呼叫音
			this.stopCallAudio();
			this.clearCountdown();
			
			console.log('用户超时未接听群聊邀请');
			// 超时信令由后端按同一绝对截止时间兜底发送。
			this.isShow = false;
			this.pendingRtcMessages = [];
		}
	}
}
</script>

<style lang="scss" scoped>
/* 固定定位在右下角 */
.rtc-group-join-fixed {
	position: fixed;
	right: 20px;
	bottom: 20px;
	z-index: 9999;
}

.rtc-group-join {
	width: 300px;
	height: 320px; /* 增加高度，为按钮留出更多空间 */
	padding: 20px;
	background-color: #fff;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
	border-radius: 8px;
	border: 1px solid #e4e7ed;

	.host-info {
		display: flex;
		flex-direction: column;
		font-size: 16px;
		padding: 10px;
		height: 100px;
		align-items: center;

		.host-text {
			margin-top: 5px;
			font-weight: 500;
		}
	}

	.users-info {
		font-size: 16px;
		margin-top: 15px; /* 减少上边距 */

		.call-status {
			width: 100%;
			text-align: center;
		}

		.user-list {
			display: flex;
			padding: 5px 5px;
			height: 70px; /* 减少高度，为按钮留出更多空间 */
			flex-wrap: wrap;
			justify-content: center;

			.user-item {
				padding: 2px;
			}
		}
		.countdown-tip {
			margin-top: 8px;
			text-align: center;
			color: #909399;
			font-size: 12px;
		}
	}

	/* 使用单聊的按钮样式 */
	.btn-group {
		display: flex;
		justify-content: center; /* 改回center，让按钮在弹出框中居中 */
		align-items: center; /* 添加垂直居中 */
		margin: 10px auto 0; /* 使用margin: 0 auto来强制居中 */
		width: 100%;
		padding: 0 35px 0 0; /* 上左下右  左边25px，右边35px，让绿色按钮和"未接听"文字对齐 */
		position: relative; /* 确保按钮定位正确 */
		gap: 40px; /* 添加按钮之间的间距 */

		.icon {
			font-size: 60px;
			cursor: pointer;
			border-radius: 50%;
			transition: all 0.3s ease;
			display: flex; /* 确保图标正确显示 */
			align-items: center;
			justify-content: center;
			flex-shrink: 0; /* 防止按钮被压缩 */

			&.accept {
				color: #45c854;
				animation: anim 2s ease-in infinite, vibration 2s ease-in infinite;

				@keyframes anim {
					0% {
						box-shadow: 0 1px 0 4px #ffffff;
					}

					10% {
						box-shadow: 0 1px 0 8px rgba(69, 200, 84, 0.45);
					}

					25% {
						box-shadow: 0 1px 0 12px rgba(69, 200, 84, 0.32), 0 1px 0 16px rgba(122, 226, 132, 0.24);
					}

					50% {
						box-shadow: 0 2px 5px 10px rgba(69, 200, 84, 0.22), 0 2px 5px 23px rgba(248, 248, 255, 1);
					}
				}

				@keyframes vibration {
					0% {
						transform: rotate(0deg);
					}

					25% {
						transform: rotate(20deg);
					}

					50% {
						transform: rotate(0deg);
					}

					75% {
						transform: rotate(-15deg);
					}

					100% {
						transform: rotate(0deg);
					}
				}

				&:hover {
					transform: scale(1.1);
				}
			}

			&.reject {
				color: red;
				
				&:hover {
					transform: scale(1.1);
				}
			}
		}
	}
}
</style>
